export const JUSTIFY_CONTENT_CLASSES = {
    normal: 'justify-normal',
    'flex-start': 'justify-start',
    'flex-end': 'justify-end',
    center: 'justify-center',
    'space-between': 'justify-between',
    'space-around': 'justify-around',
    'space-evenly': 'justify-evenly',
    stretch: 'justify-stretch',
    start: '[justify-content:start]',
    end: '[justify-content:end]',
    left: '[justify-content:left]',
    right: '[justify-content:right]',
};
export const applyJustifyContent = (justifyContent) => [
    ...(justifyContent ? [JUSTIFY_CONTENT_CLASSES[justifyContent]] : []),
];
